import {
  DataTableSortableColumn,
  CurrencyFormatted,
  Typography,
  ColumnDef,
  Anchor,
  Badge,
} from '@ui/components';
import { CostCenterTableDto } from '@interfaces/models';
import { Link } from 'react-router-dom';
import { TFunction } from 'i18next';

export const getCostCentersColumns = (
  t: TFunction,
  currency: string,
): ColumnDef<CostCenterTableDto>[] => {
  return [
    {
      accessorKey: 'name',
      size: 150,
      maxSize: 150,
      header: ({ column }) => (
        <DataTableSortableColumn label={t('COST_CENTERS.TABLE_HEADER_NAME')} column={column} />
      ),
      cell: ({ row }) => (
        <div className="flex items-center gap-2">
          <Anchor asChild>
            <Link to={`${row.original.id}`}>
              <Typography className="text-paragraph" variant="labelMediumBook" element="span">
                {row.original.name}
              </Typography>
            </Link>
          </Anchor>
          {row.original.defaultCostCenter && (
            <Badge variant="blue">{t('COST_CENTERS.DEFAULT_COST_CENTER_BADGE')}</Badge>
          )}
        </div>
      ),
    },
    {
      accessorKey: 'accountNumber',
      header: t('COST_CENTERS.TABLE_HEADER_ACCOUNT_NUMBER'),
    },
    {
      accessorKey: 'currentMonthExpenses',
      size: 150,
      header: ({ column }) => (
        <DataTableSortableColumn
          label={t('COST_CENTERS.TABLE_HEADER_CURRENT_MONTH_EXPENSES')}
          className="flex justify-end"
          column={column}
        />
      ),
      cell: ({ row }) => (
        <CurrencyFormatted
          value={row.original.currentMonthExpenses ?? 0}
          className="flex items-center justify-end"
          currency={currency}
        />
      ),
    },
    {
      accessorKey: 'currentBalance',

      size: 150,
      header: ({ column }) => (
        <DataTableSortableColumn
          label={t('COST_CENTERS.TABLE_HEADER_CURRENT_BALANCE')}
          className="flex justify-end"
          column={column}
        />
      ),
      cell: ({ row }) => (
        <CurrencyFormatted
          className="flex items-center justify-end"
          value={row.original.currentBalance ?? 0}
          currency={currency}
        />
      ),
    },
  ];
};
